module.exports = __webpack_public_path__ + "static/img/LxwlzjscT.c8b8944d.png";